import React from 'react'
import { Form, FormGroup, FormFeedback, Row, Col, Button } from 'reactstrap';
import { FaLock } from "react-icons/fa";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { NavLink } from 'react-router-dom'
import logo from '../image/login-icon.png';
import ErrorSwal from '../components/SwalError'
import { useTranslation } from 'react-i18next'
import { ResetPass } from '../components/functions/LoginPage';
import { useLocation } from 'react-router';
import queryString from 'query-string'

const schema = yup.object().shape({
    password: yup
        .string()
        .required("Please enter your Password")
        .min(6, "The minimum entered is 6 or more."),
    confirmpassword: yup
        .string()
        .required("Please enter your Confirm Password")
        .min(6, "The minimum entered is 6 or more."),
})

const ResetPassword = () => {

    const { register, handleSubmit, errors } = useForm({
        resolver: yupResolver(schema),
    });

    const { t } = useTranslation()
    const location = useLocation()
    const { token } = queryString.parse(location.search)
    const [invalidUser, setInvalidUser] = React.useState(false)

    const verifyToken = async () => {
        try {
            await ResetPass(token, '')
        } catch (error) {
            if (error?.response?.data) {
                const { data } = error.response
                setInvalidUser(data.message)
            }
        }

    }

    React.useEffect(() => {
        verifyToken()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const onSubmit = async (data) => {

        console.log(data)
        if (data.password !== data.confirmpassword) {
            ErrorSwal({
                title: 'error',
                text: "Passwords do not match.",
                icon: 'error'
            })
        }
        else {
            await ResetPass(token, data.password)
                .then((response) => {
                    ErrorSwal({
                        title: 'Success',
                        text: response.data.message,
                        icon: 'success'
                    })
                })
                .catch(error => {
                    if (error?.response?.data) {
                        const { data } = error.response
                        ErrorSwal({
                            title: 'error',
                            text: data.message,
                            icon: 'error'
                        })
                    }
                })
        }

    }

    if (invalidUser) {
        ErrorSwal({
            title: 'error',
            text: invalidUser,
            icon: 'error'
        })
    }


    return (
        <>
            <div id="auth" style={{ backgroundColor: 'white' }}>

                <Row className="row h-100">
                    <Col lg={5} >
                        <div id="auth-left">
                            <div className="auth-logo">
                                <img src={logo} alt="Logo" srcSet="" />
                            </div>
                            {invalidUser ? (
                                <div>
                                    <h1 className="auth-title mt-4 mb-4" style={{ fontSize: '2.25rem', textAlign: 'center' }}> {t('t_token_expire')} </h1>
                                    <p class="auth-subtitle mb-4" style={{ fontSize: '1.25rem', textAlign: 'center' }}>  {t('t_reset_again')} </p>
                                    <div className="text-center mt-5 text-lg fs-4">
                                        <p className="text-gray-600">
                                            <NavLink to="/forget-password" className="btn btn-primary btn-block btn-lg shadow-lg">
                                                {t('t_forget_pass')}
                                            </NavLink>
                                        </p>
                                    </div>
                                </div>
                            ) : (
                                <div>

                                    <h1 className="auth-title mb-4" style={{ fontSize: '2.25rem', textAlign: 'center' }}>  {t('t_reset_pass')} </h1>
                                    <Form onSubmit={handleSubmit(onSubmit)}>

                                        <FormGroup className="position-relative has-icon-left mb-4" >
                                            <div className="form-control-icon">
                                                <FaLock size='2em' />
                                            </div>
                                            <input
                                                type="password"
                                                name="password"
                                                ref={register}
                                                className={`form-control-xl form-control ${errors.password ? "is-invalid" : ""}`}
                                                placeholder={t('i_pass')}
                                            />

                                            {errors.password && (
                                                <FormFeedback type="invalid">
                                                    {errors.password.message}
                                                </FormFeedback>
                                            )}
                                        </FormGroup>
                                        <FormGroup className="position-relative has-icon-left mb-4" >
                                            <div className="form-control-icon">
                                                <FaLock size='2em' />
                                            </div>
                                            <input
                                                type="password"
                                                name="confirmpassword"
                                                ref={register}
                                                className={`form-control-xl form-control ${errors.confirmpassword ? "is-invalid" : ""}`}
                                                placeholder={t('i_confirmpassword')}
                                            />

                                            {errors.confirmpassword && (
                                                <FormFeedback type="invalid">
                                                    {errors.confirmpassword.message}
                                                </FormFeedback>
                                            )}
                                        </FormGroup>


                                        <Button color="primary" type="submit" className="btn btn-primary btn-block btn-lg shadow-lg mt-5">
                                            {t('b_send')}
                                        </Button>
                                    </Form>
                                </div>
                            )

                            }

                        </div>
                    </Col>
                    <Col lg={7} className="d-none d-lg-block">
                        <div id="auth-right">
                        </div>
                    </Col>


                </Row>
            </div>
        </ >
    )
}

export default ResetPassword;
